<template>
  <c-container>
    <c-row>
      <c-col>
        <c-data-table
            v-bind:items="items"
            v-bind:fields="fields"
            column-filter
            v-bind:items-per-page="20"
            hover
            sorter
            pagination
        >
          <template #price="{item}">
            <td>
              {{ item.price.toFixed(2) }} zł/{{ item.unit }}
            </td>
          </template>
          <template #actions="{item}">
            <td>
              <template v-if="item.pickCount === 0">
                <c-button color="success" v-on:click="() => onAddClick(item)">
                  Do koszyka
                </c-button>
              </template>
              <template v-else>
                <div class="mb-2">
                  <strong>W koszyku:</strong>
                  {{ item.pickCount }} {{ item.unit }}
                  ({{ (item.price * item.pickCount).toFixed(2) }} zł)
                </div>
                <c-button-group>
                  <c-button color="danger"
                            v-on:click="() => onDeleteClick(item)">Usuń z
                    koszyka
                  </c-button>
                </c-button-group>
              </template>
            </td>
          </template>
        </c-data-table>
      </c-col>
    </c-row>
    <c-modal
        total="Usuwanie z koszyka"
        color="danger"
        :show.sync="deleteModal"
        :close-on-backdrop="false"
    >
      <div v-if="deleteModal">
        Czy na pewno chcesz usunąć z koszyka towar
        <strong>{{ getItemFromPk(deleteModalPk).name }}</strong>?
      </div>
      <template v-slot:footer>
        <c-button color="danger"
                  v-on:click="() => onDeleteModalSave(deleteModalPk)">
          Tak, usuń
        </c-button>
        <c-button color="secondary" v-on:click="deleteModal = false">
          Nie, nie usuwaj
        </c-button>
      </template>
    </c-modal>
    <c-modal
        title="Dodawanie do koszyka"
        color="primary"
        :show.sync="addModal"
        :close-on-backdrop="false"
    >
      <div v-if="addModal">
        Podaj zamawianą liczbę
        <strong>{{ getItemFromPk(addModalPk).unit }}</strong> towaru
        {{ getItemFromPk(addModalPk).name }}:
        <c-input ref="modal_input" step="1" v-model="addModalVal"
                 type="number"></c-input>
      </div>
      <div v-if="addModalWarning">
        <template v-if="getItemFromPk(addModalPk).unit === 'szt'">
          <strong>Błąd: podana liczba musi być dodatnia oraz całkowita (bez ułamków).</strong>
        </template>
        <template v-else>
          <strong>Błąd: podana liczba musi być dodatnia.</strong>
        </template>
      </div>
      <template v-slot:footer>
        <c-button color="primary"
                  v-on:click="() => onAddModalSave(addModalPk)">
          Zapisz
        </c-button>
        <c-button color="secondary" v-on:click="onAddModalCancel">
          Anuluj
        </c-button>
      </template>
    </c-modal>
  </c-container>
</template>
<script>
export default {
  name: 'ProductsList',
  data: function () {
    return {
      fields: [
        {key: 'name', label: 'Nazwa'},
        {key: 'price', label: 'Cena'},
        {key: 'actions', label: 'Twój koszyk'}
      ],
      addModal: false,
      addModalPk: 1,
      addModalVal: null,
      addModalWarning: false,
      deleteModal: false,
      deleteModalPk: 1
    }
  },
  computed: {
    products() {
      return this.$store.getters.products
    },
    items() {
      return this.$store.getters.products.map(product => ({
        name: product.fields.name,
        price: parseFloat(product.fields.unit_price),
        unit: product.fields.unit,
        pickCount: product.pickCount,
        pk: product.pk
      }))
    }
  },
  methods: {
    getItemFromPk(pk) {
      for (const item of this.items)
        if (item.pk === pk)
          return item
      return null
    },
    onAddClick(item) {
      this.addModalPk = item.pk
      this.addModal = true
      this.$nextTick(() => this.$refs.modal_input.$el.querySelector('input').focus())
    },
    onAddModalSave(itemPk) {
      if ((this.getItemFromPk(itemPk).unit === 'szt' && !Number.isInteger(parseFloat(this.addModalVal))) || parseFloat(this.addModalVal) <= 0) {
        this.addModalWarning = true
        return
      } else this.addModalWarning = false
      this.addModal = false
      this.$store.dispatch('setPickCount', {
        productPk: itemPk,
        count: Math.round(this.addModalVal * 1000) / 1000
      })
      this.addModalVal = null
    },
    onAddModalCancel() {
      this.addModal = false
      this.addModalWarning = false
      this.addModalVal = null
    },
    onDeleteClick(item) {
      this.deleteModalPk = item.pk
      this.deleteModal = true
    },
    onDeleteModalSave(itemPk) {
      this.deleteModal = false
      this.$store.dispatch('setPickCount', {
        productPk: itemPk,
        count: 0
      })
    }
  }
}
</script>